export default __webpack_public_path__ + "static/media/bg6.bc934d63.png";